import React from 'react'
import { useDispatch } from 'react-redux'
import { setCurrentRoute } from '../../store/itinerary/itinerarySlice'
import useOnClick from '../utils/useOnClick'
import { navigateTo } from '../../store/history/history.actions'
import { ROUTE_ITINERARY_ROADBOOK } from '../../routes'
import { PUB_TAG } from '../analytics/PublisherTagsService'
import { RI_CLIC_ITI, TAG_MULTIPATH_CTA } from '../analytics/analytics.tagids.constants'
import { useAction } from '../utils/react-redux'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM
} from '../genericComponents/buttons/RectangleActionButton'
import ItineraryButtonContainer from './ItineraryButtonContainer'
import TagActionButton from '../genericComponents/TagActionButton'
import { CLICKED_BUTTON } from '../analytics/analytics.constants'
import { useT } from '../i18n/T'

const GotoRoadbookButton = ({ elementRef, className, route }) => {
  const dispatch = useDispatch()
  const execNavigateTo = useAction(navigateTo)

  const navigateToRoadbook = useOnClick(() => {
    dispatch(setCurrentRoute(route.routeId))
    execNavigateTo({
      route: ROUTE_ITINERARY_ROADBOOK,
      routeOptions: {
        avoidRefetchingPageData: true
      }
    })
  })

  return (
    <ItineraryButtonContainer className={className}>
      <TagActionButton type={RI_CLIC_ITI} key={route.routeId}>
        <RectangleActionButton
          color={COLOR_GREY_EMPTY}
          elementRef={elementRef}
          onClick={navigateToRoadbook}
          deferClick
          tagData={{
            tagInfo: { provider: route.provider, tag: PUB_TAG.PUB_MULTIPATH_ROADBOOK },
            type: TAG_MULTIPATH_CTA,
            shouldTagImpression: true
          }}
          dataset={{ [CLICKED_BUTTON]: useT('itinerary.result.button.roadbook') }}
          label={'itinerary.result.button.roadbook'}
          size={SIZE_MEDIUM}
        />
      </TagActionButton>
    </ItineraryButtonContainer>
  )
}

export default GotoRoadbookButton
